<div
    class="flex flex-col bg-white p-3 shadow-md transition-all duration-100 ease-in-out"
    [ngClass]="{
        'mb-4': !accordionGroup.value,
        'mb-0': accordionGroup.value,
        'pt-0': isMobileView
    }">
    <ng-content></ng-content>

    <div class="border-ironside_grey-100 mb-3 mt-3 border-t border-solid dark:border-contrast-yellow"></div>

    <div class="flex-justify-between flex items-center">
        <div
            class="sr-app-light:font-bold text-xs font-light leading-4 text-[#5E5E5E] dark:text-contrast-yellow"
            *ngIf="isNotExpandableFilter">
            {{ 'FILTER_ROUTES' | translate }}
        </div>

        <ion-button
            class="pn-app-light:text-primary pn-light:text-primary leave-now-button var-app-light:text-black my-0 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            id="explore-stop-details-time"
            [attr.aria-label]="isTimeFilterSet ? timeLabel : ('LEAVE_NOW' | translate)"
            fill="clear"
            size="small">
            <mat-icon
                class="pn-app-light:text-primary pn-light:text-primary var-app-light:text-black mr-1 text-secondary dark:filter-yellow"
                >schedule</mat-icon
            >
            {{ isTimeFilterSet ? timeLabel : ('LEAVE_NOW' | translate) }}
        </ion-button>
        <ion-button
            class="pn-app-light:text-primary pn-light:text-primary var-app-light:text-black my-0 -mr-2 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            *ngIf="!isNotExpandableFilter"
            [ngClass]="filterButtonClasses"
            [attr.aria-label]="'FILTER' | translate"
            (click)="toggleFilterOpen()"
            fill="clear"
            size="small">
            <ion-icon
                class="pn-app-light:text-primary pn-light:text-primary var-app-light:text-black mr-1 text-base"
                [ngClass]="filterIconClasses"
                name="options-outline"></ion-icon>
            <span [ngClass]="filterTextClasses">
                {{ 'FILTER' | translate }}
            </span>
        </ion-button>
    </div>
</div>
<ion-accordion-group class="route-filter" #filterAccordionGroup>
    <ion-accordion value="first">
        <ion-row class="filter-scroll px-5 py-4" slot="content">
            <rwidget-route-short-name
                class="mr-3 cursor-pointer"
                *ngFor="let route of routes; let i = index"
                [label]="route.shortName"
                [color]="route?.icon?.color || route.color"
                [textColor]="route?.icon?.textColor"
                [shape]="route?.icon?.shape || ShapeType.ROUNDED"
                [isDisabled]="!isRouteSelected(route)"
                [isSelected]="isRouteSelected(route)"
                [disabledColor]="routeIconDisabledColor"
                [size]="routeIconSize"
                [textSize]="routeIconTextSize"
                (click)="toggleRoute(route)"></rwidget-route-short-name>
        </ion-row>
    </ion-accordion>
    <ion-accordion value="second">
        <div class="h-4 w-full" slot="content"></div>
    </ion-accordion>
</ion-accordion-group>

<ridango-ui-datetime-select
    [(ngModel)]="filterDepartTime"
    [minDate]="minDateForFilter"
    [maxDate]="maxDateForFilter"
    [showDepartArriveToggle]="env.EXPLORE?.STOP_VIEW?.SHOW_DEPART_ARRIVE_TOGGLE"
    [triggerId]="'explore-stop-details-time'"
    (ngModelChange)="onFilterDepartTimeChange($event)"></ridango-ui-datetime-select>
